<!-- Modal Header -->
<div class="modal-header">
    <h4 class="modal-title">Add Customer Bank Account</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
</div>

<div class="modal-body">
    <div class="d-grid grid-1-col gap-4">
        <div>
            <label for="bankOption">Bank</label>
            <select class="form-select" name="bankOption" id="bankOption" [ngModel]="isOtherBank() ? 'Other' : account().Bank" (ngModelChange)="bankChanged($event)">
                <option value="Other">Other</option>
            @for (b of BANK_CONFIG; track b.code) {
                <option [value]="b.bankName">{{ b.bankName }}</option>
            }
            </select>
        </div>

    @if (isOtherBank()) {
        <div>
            <label for="bank">Other (Please specify bank name)</label>
            <input type="text" required class="form-control" name="bank" id="bank" [(ngModel)]="account().Bank" (keypress)="!sharedService.isNumberKey($event)" />
        </div>
    }
        <div>
            <label for="accountNumber">Account Number</label>
            <input type="text" required class="form-control" name="accountNumber" id="accountNumber" [(ngModel)]="account().AccountNumber" (keypress)="sharedService.isNumberKey($event)" />
        </div>
        <div>
            <label for="holderName">Holder Name</label>
            <input type="text" required class="form-control" name="holderName" id="holderName" [(ngModel)]="account().HolderName" (keypress)="!sharedService.isNumberKey($event)" />
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-success" type="button" (click)="submit()"
        [disabled]="disabledSubmit">Add</button>
    <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
</div>